export const GET_LIST_TINCHAP = "GET_LIST_TINCHAP";
export const GET_LIST_TINCHAP_SUCCESS = "GET_LIST_TINCHAP_SUCCESS";
export const GET_LIST_TINCHAP_FAILURE = "GET_LIST_TINCHAP_FAILURE";
